import { render, staticRenderFns } from "./modalReclamos.vue?vue&type=template&id=177d6c34&"
import script from "./modalReclamos.vue?vue&type=script&lang=js&"
export * from "./modalReclamos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports